var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceBox8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 300,
    viewBox: "0 0 389 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1039_12464)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 389,
    height: 300,
    rx: 4,
    fill: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.5205 -105C-18.4341 -90.7928 24.2448 -50.5925 80.4933 -60.3341C111.27 -65.6711 155.451 -50.3865 169.854 -14.6701C169.854 -14.6701 184.292 55.7993 259.533 41.0767C291.031 34.9149 322.148 51.8294 344.476 80.84C354.302 93.5975 372.494 115.962 370.059 130.494C369.009 136.771 363.713 140.602 359.565 144.943C348.014 157.08 342.395 177.918 353.142 197.234C363.024 214.979 387.951 221.197 400.521 236.864C459.658 310.563 371.426 331.265 350.689 335.03",
    stroke: "#174997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeDasharray: "11.32 11.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-372.521 -105C-359.434 -90.7928 -316.755 -50.5925 -260.507 -60.3341C-229.73 -65.6711 -185.549 -50.3865 -171.146 -14.6701C-171.146 -14.6701 -156.708 55.7993 -81.4665 41.0767C-49.9692 34.9149 -18.8518 51.8294 3.47638 80.84C13.3021 93.5975 31.4937 115.962 29.0595 130.494C28.0085 136.771 22.7129 140.602 18.5649 144.943C7.01365 157.08 1.3947 177.918 12.1423 197.234C22.0242 214.979 46.9514 221.197 59.5208 236.864C118.658 310.563 30.4258 331.265 9.68887 335.03",
    stroke: "#174997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeDasharray: "11.32 11.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.796 171.322C242.029 188.019 225.615 200.785 213.291 201.551C197.031 202.572 185.423 187.917 183.787 171.322C182.407 156.922 187.52 157.126 191.304 151.152C195.906 143.901 204.548 139.867 213.24 139.867C229.603 139.867 243.818 148.905 242.796 171.322Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.746 200.02H201.889V228.564H224.746V200.02Z",
    fill: "#E3B5AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.012 183.373C243.102 177.194 248.267 176.939 250.415 184.241C252.562 191.543 245.455 197.568 239.625 195.322C233.796 193.075 239.012 183.373 239.012 183.373Z",
    fill: "#E3B5AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.818 183.526C246.528 183.015 247.96 191.134 241.978 191.441L243.205 188.581L242.029 186.232L243.818 183.526Z",
    fill: "#D78F97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.057 192.513C244.534 188.785 242.028 186.232 242.028 186.232C242.028 186.232 245.352 179.441 246.681 184.649",
    stroke: "#C87E84",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.469 183.373C183.378 177.194 178.214 176.939 176.066 184.241C173.918 191.543 181.026 197.568 186.855 195.322C192.684 193.075 187.469 183.373 187.469 183.373Z",
    fill: "#E3B5AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.662 183.526C179.952 183.015 178.521 191.134 184.503 191.441L183.276 188.581L184.452 186.232L182.662 183.526Z",
    fill: "#D78F97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.424 192.513C181.946 188.785 184.452 186.232 184.452 186.232C184.452 186.232 181.128 179.441 179.799 184.649",
    stroke: "#C87E84",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.746 200.632V211.253C216.513 222.385 201.889 218.759 201.889 218.759L202.144 200.632H224.746Z",
    fill: "#C87E84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.343 212.836C199.69 212.836 188.646 201.806 188.646 188.173V170.147C188.646 160.956 196.111 153.501 205.315 153.501H221.371C230.575 153.501 238.041 160.956 238.041 170.147V188.173C238.041 201.806 226.996 212.836 213.343 212.836Z",
    fill: "#E3B5AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.126 191.39C217.126 193.483 215.439 195.168 213.343 195.168C211.246 195.168 209.559 193.483 209.559 191.39",
    stroke: "#B83D5D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.253 154.573C191.253 154.573 186.907 147.425 192.327 141.093C192.327 141.093 196.213 148.293 191.253 154.573Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.452 152.888C193.452 152.888 187.418 158.709 180.055 154.828C180.055 154.828 186.191 149.416 193.452 152.888Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.525 182.555C203.525 184.598 202.656 186.232 201.582 186.232C200.508 186.232 199.639 184.598 199.639 182.555C199.639 180.513 200.508 178.879 201.582 178.879C202.656 178.879 203.525 180.513 203.525 182.555Z",
    fill: "#36364F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.135 184.88C211.572 179.601 208.45 174.158 203.163 172.724C197.877 171.289 192.426 174.406 190.99 179.686C189.553 184.965 192.675 190.408 197.961 191.843C203.248 193.277 208.699 190.16 210.135 184.88Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.046 182.555C227.046 184.598 226.177 186.232 225.103 186.232C224.029 186.232 223.16 184.598 223.16 182.555C223.16 180.513 224.029 178.879 225.103 178.879C226.177 178.879 227.046 180.513 227.046 182.555Z",
    fill: "#36364F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.625 184.916C237.087 179.644 233.992 174.186 228.713 172.726C223.433 171.265 217.967 174.356 216.505 179.628C215.043 184.901 218.138 190.359 223.417 191.819C228.697 193.279 234.163 190.189 235.625 184.916Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.713 160.548C191.713 160.548 207.411 152.276 217.842 158.25C228.274 164.225 229.45 176.582 239.728 173.416C239.728 173.416 247.551 169.995 238.961 157.995C230.37 145.995 224.49 143.697 213.291 146.302C202.093 148.906 194.781 150.897 191.713 160.548Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.1 160.395C191.1 160.395 196.264 153.552 203.525 151.714C210.786 149.876 218.814 158.812 218.814 158.812C218.814 158.812 200.201 156.156 191.1 160.395Z",
    fill: "#9A304F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.696 169.024C188.696 169.024 190.434 181.739 188.696 189.501C188.696 189.501 186.139 169.79 188.696 169.024Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.836 169.024C237.836 169.024 236.098 181.739 237.836 189.501C237.836 189.501 240.393 169.79 237.836 169.024Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.031 168.054C203.32 166.777 198.565 165.348 194.116 168.513C193.349 169.024 193.656 170.199 194.577 170.352C196.008 170.607 198.054 170.862 200.355 170.811C202.144 170.811 204.292 170.352 205.877 169.943C206.746 169.739 206.9 168.462 206.031 168.054Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.058 168.054C229.348 166.777 224.592 165.348 220.144 168.513C219.377 169.024 219.683 170.199 220.604 170.352C222.036 170.607 224.081 170.862 226.382 170.811C228.172 170.811 230.319 170.352 231.904 169.943C232.774 169.739 232.927 168.462 232.058 168.054Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.678 200.275C221.422 200.734 221.115 201.194 220.706 201.705C219.377 203.288 217.127 204.819 213.292 204.87H212.985C209.406 204.819 207.156 203.441 205.826 201.96C205.315 201.398 204.906 200.785 204.65 200.275C203.985 199.049 203.832 198.079 203.832 198.079L222.496 198.13C222.496 198.13 222.342 199.1 221.678 200.275Z",
    fill: "#C33E5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.678 200.275C221.422 200.734 221.115 201.194 220.706 201.705C216.411 199.815 211.298 199.458 205.826 201.96C205.315 201.398 204.906 200.785 204.65 200.275C203.985 199.049 203.832 198.079 203.832 198.079L222.496 198.13C222.496 198.13 222.342 199.1 221.678 200.275Z",
    fill: "#36364F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.6 299.54L125.393 299.693C125.393 299.693 128.512 293.157 133.012 284.528C133.318 283.915 133.676 283.251 134.034 282.587C140.17 270.894 148.403 256.137 154.846 248.171C162.26 238.98 179.799 232.393 191.662 228.818C198.616 226.725 203.627 225.652 203.627 225.652H222.854C222.854 225.652 227.353 226.623 233.745 228.512C245.608 232.035 263.403 239.235 271.635 248.171C273.425 250.162 275.164 252.511 276.749 255.167C286.873 272.017 292.6 299.54 292.6 299.54Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M292.6 299.541L125.393 299.694C125.393 299.694 128.512 293.158 133.012 284.528C216.462 309.038 260.386 268.903 270.459 258.027C272.096 256.29 274.345 255.218 276.698 255.167H276.749C286.873 272.018 292.6 299.541 292.6 299.541Z",
    fill: "#D9751F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.735 183.935H215.951",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.745 228.512C213.036 251.235 191.713 228.818 191.713 228.818C198.667 226.725 203.678 225.652 203.678 225.652H222.905C222.853 225.652 227.353 226.623 233.745 228.512Z",
    fill: "#E3B5AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.629 273.805V299.745",
    stroke: "#DC831E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.629 290.349L160.675 281.464",
    stroke: "#DC831E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.545 273.805V299.745",
    stroke: "#DC831E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.545 290.349L264.732 282.485",
    stroke: "#DC831E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.69 238.674C190.69 238.674 216.36 256.188 233.745 237.806",
    stroke: "#DC831E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.66 270.791L247.461 280.69L253.261 270.791H257.548L249.73 282.897L257.548 295.002H253.261L247.461 285.608L241.66 295.002H237.373L245.065 282.897L237.373 270.791H241.66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.1 149.773C196.878 125.621 254.608 128.276 243.87 175.356C240.648 189.449 217.127 143.288 196.827 154.624C195.293 155.492 193.401 155.237 192.174 154.063C190.946 152.99 190.742 151.356 191.1 149.773Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6496 267.115V268.749C86.6838 269.107 85.9168 271.609 85.9168 274.673V275.694C85.9168 278.758 86.6327 281.26 89.6496 281.617V283.251H32.6865C30.3343 283.251 28.4424 281.362 28.4424 279.013V271.353C28.4424 269.005 30.3343 267.115 32.6865 267.115H89.6496Z",
    fill: "#4B7195"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7807 279.932C89.1387 280.749 88.4739 281.617 87.6046 281.617L33.1982 281.668V268.698L87.6046 268.749C87.9114 268.749 88.2182 268.851 88.4228 269.056C88.7807 269.362 88.9853 269.924 88.7807 270.434C88.3205 271.507 88.3205 272.988 88.3205 274.673V275.694C88.3205 277.328 88.3205 278.86 88.7807 279.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M88.4222 269.056C87.3995 269.107 39.2825 271.609 35.9588 276.256C35.0384 277.532 34.0669 278.247 33.1465 278.349V268.698L87.5529 268.749C87.9108 268.749 88.2176 268.851 88.4222 269.056Z",
    fill: "#A3D5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0098 283.251H31.2033C29.6692 283.251 28.4932 282.025 28.4932 280.544V269.872C28.4932 268.34 29.7204 267.166 31.2033 267.166H36.0098V283.251Z",
    fill: "#4B7195"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M88.7805 279.932C89.1384 280.749 88.4737 281.617 87.6044 281.617H76.7129C85.3545 280.647 84.792 273.549 84.792 273.549C84.8943 273.191 77.9912 269.055 78.0935 268.749H87.5533C87.8601 268.749 88.1669 268.851 88.3714 269.055C88.7293 269.362 88.9339 269.923 88.7293 270.434C88.2691 271.506 88.2691 272.987 88.2691 274.672V275.694C88.3203 277.328 88.3203 278.859 88.7805 279.932Z",
    fill: "#A3D5E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M88.3203 274.213H36.0615V275.387H88.3203V274.213Z",
    fill: "#A3D5E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M88.3203 271.608H36.0615V272.783H88.3203V271.608Z",
    fill: "#A3D5E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M88.3203 277.583H36.0615V278.757H88.3203V277.583Z",
    fill: "#A3D5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4974 279.217L68.7362 276.459L65.9238 279.217V271.608H71.4974V279.217Z",
    fill: "#C33E5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7345 283.2V284.834C92.7688 285.192 92.0018 287.694 92.0018 290.757V291.779C92.0018 294.843 92.7176 297.345 95.7345 297.702V299.336H38.7715C36.4193 299.336 34.5273 297.447 34.5273 295.098V287.438C34.5273 285.09 36.4193 283.2 38.7715 283.2H95.7345Z",
    fill: "#C33E5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8657 296.017C95.2236 296.834 94.5589 297.702 93.6896 297.702L39.2832 297.753V284.834L93.6896 284.885C93.9964 284.885 94.3032 284.987 94.5077 285.191C94.8657 285.498 95.0702 286.059 94.8657 286.57C94.4055 287.642 94.4055 289.123 94.4055 290.808V291.83C94.4055 293.413 94.4055 294.944 94.8657 296.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.5071 285.141C93.4844 285.192 45.3675 287.694 42.0438 292.34C41.1234 293.617 40.1519 294.332 39.2314 294.434V284.783L93.6379 284.834C93.9958 284.834 94.3026 284.936 94.5071 285.141Z",
    fill: "#A3D5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0948 299.336H37.2882C35.7542 299.336 34.5781 298.11 34.5781 296.629V285.957C34.5781 284.425 35.8053 283.251 37.2882 283.251H42.0948V299.336Z",
    fill: "#C33E5D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.8654 296.017C95.2234 296.834 94.5586 297.702 93.6894 297.702H82.7979C91.4395 296.732 90.877 289.634 90.877 289.634C90.9793 289.276 84.0762 285.14 84.1785 284.834H93.6382C93.945 284.834 94.2518 284.936 94.4564 285.14C94.8143 285.447 95.0188 286.008 94.8143 286.519C94.3541 287.591 94.3541 289.072 94.3541 290.757V291.779C94.4052 293.413 94.4052 294.944 94.8654 296.017Z",
    fill: "#A3D5E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.4053 290.298H42.1465V291.472H94.4053V290.298Z",
    fill: "#A3D5E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.4053 287.693H42.1465V288.868H94.4053V287.693Z",
    fill: "#A3D5E6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.4053 293.668H42.1465V294.842H94.4053V293.668Z",
    fill: "#A3D5E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.729 296.324L85.7633 293.413L82.8486 296.324V288.256H88.729V296.324Z",
    fill: "#C33E5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.216 127.408C363.216 127.357 363.216 127.306 363.216 127.306C363.216 127.255 363.216 127.203 363.216 127.203C363.83 126.897 364.443 126.591 365.057 126.182C365.722 125.723 366.386 125.212 367 124.65L366.847 124.14C366.744 123.527 366.489 122.965 366.284 122.404C366.182 122.148 366.028 121.842 365.875 121.587C365.773 121.28 365.619 121.025 365.415 120.77L365.159 120.31C364.341 120.31 363.472 120.412 362.705 120.565C361.989 120.718 361.324 120.923 360.711 121.178L360.557 121.025C360.813 120.412 361.017 119.748 361.12 119.033C361.273 118.267 361.375 117.399 361.375 116.582L360.915 116.327C360.659 116.174 360.404 116.021 360.097 115.868C359.841 115.714 359.534 115.612 359.279 115.459C358.716 115.255 358.154 114.999 357.54 114.897L357.029 114.744C356.415 115.357 355.904 116.021 355.495 116.685C355.086 117.297 354.779 117.91 354.472 118.523C354.421 118.523 354.37 118.523 354.37 118.523C354.319 118.523 354.268 118.523 354.268 118.523C354.012 117.91 353.654 117.297 353.245 116.685C352.785 116.021 352.273 115.357 351.711 114.744L351.2 114.897C350.586 114.999 350.024 115.255 349.461 115.459C349.205 115.561 348.899 115.714 348.643 115.868C348.387 115.97 348.08 116.123 347.825 116.327L347.365 116.582C347.365 117.399 347.467 118.267 347.62 119.033C347.774 119.748 347.978 120.412 348.234 121.025C348.183 121.076 348.132 121.127 348.08 121.178C347.467 120.923 346.751 120.718 346.086 120.565C345.319 120.412 344.45 120.31 343.632 120.31L343.325 120.77C343.172 121.025 343.018 121.28 342.865 121.587C342.763 121.842 342.609 122.148 342.507 122.404C342.302 122.965 342.047 123.527 341.944 124.14L341.791 124.65C342.405 125.263 343.069 125.774 343.734 126.182C344.348 126.591 344.961 126.897 345.575 127.203C345.575 127.255 345.575 127.255 345.575 127.306C345.575 127.357 345.575 127.408 345.575 127.408C344.961 127.663 344.348 128.02 343.734 128.429C343.069 128.889 342.405 129.399 341.791 129.961L341.944 130.471C342.047 131.084 342.302 131.646 342.507 132.208C342.609 132.463 342.763 132.769 342.865 133.025C342.967 133.28 343.12 133.586 343.325 133.842L343.632 134.301C344.45 134.301 345.319 134.199 346.086 134.046C346.802 133.893 347.467 133.688 348.08 133.433C348.132 133.484 348.183 133.535 348.234 133.586C347.978 134.199 347.774 134.863 347.62 135.578C347.467 136.344 347.365 137.212 347.365 138.029L347.825 138.335C348.08 138.488 348.336 138.642 348.643 138.744C348.899 138.897 349.205 138.999 349.461 139.152C350.024 139.356 350.586 139.612 351.2 139.714L351.711 139.867C352.273 139.254 352.836 138.59 353.245 137.927C353.654 137.314 353.961 136.701 354.268 136.088C354.319 136.088 354.37 136.088 354.37 136.088C354.421 136.088 354.472 136.088 354.472 136.088C354.779 136.701 355.086 137.314 355.495 137.927C355.955 138.59 356.466 139.254 357.029 139.867L357.54 139.714C358.154 139.612 358.716 139.356 359.279 139.152C359.586 139.05 359.841 138.897 360.097 138.744C360.353 138.642 360.659 138.488 360.915 138.335L361.375 138.029C361.375 137.212 361.273 136.344 361.12 135.578C360.966 134.863 360.762 134.199 360.557 133.586C360.608 133.535 360.659 133.484 360.711 133.433C361.324 133.688 361.989 133.893 362.705 134.046C363.472 134.199 364.341 134.301 365.159 134.301L365.415 133.842C365.568 133.586 365.722 133.331 365.875 133.025C366.028 132.769 366.131 132.463 366.284 132.208C366.489 131.646 366.744 131.084 366.847 130.471L367 129.961C366.386 129.399 365.722 128.837 365.057 128.429C364.443 128.02 363.83 127.663 363.216 127.408ZM354.421 131.493C352.069 131.493 350.177 129.603 350.177 127.255C350.177 124.906 352.069 123.016 354.421 123.016C356.773 123.016 358.665 124.906 358.665 127.255C358.614 129.603 356.722 131.493 354.421 131.493Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.302 133.791H313.82V161.773H321.746",
    stroke: "#FD783D",
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.058 176.785H322.411V179.594H338.058V176.785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.495 181.942H322.411V184.751H346.495V181.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.593 187.1H322.411V189.908H330.593V187.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.149 187.1H333.968V189.908H342.149V187.1Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.875 187.1H345.114V189.908H356.875V187.1Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.876 181.942H349.717V184.751H356.876V181.942Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.875 176.785H341.229V179.594H356.875V176.785Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.602 158.658H362.091V189.807H362.602V158.658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.774 159.833H322.667V162.693H338.774V159.833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.416 165.144H322.667V168.003H347.416V165.144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.104 170.454H322.667V173.314H331.104V170.454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.967 170.454H334.53V173.314H342.967V170.454Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.103 170.454H345.984V173.314H358.103V170.454Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.103 165.144H350.739V168.003H358.103V165.144Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.102 159.833H341.995V162.693H358.102V159.833Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.327 41H254V131.892H300.327V41Z",
    fill: "#49496B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.038 60.3525H259.267V64.0291H294.038V60.3525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.277 68.5225H259.267V72.199H282.277V68.5225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.038 68.5225H285.703V72.199H294.038V68.5225Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.038 76.6934H272.511V80.3699H294.038V76.6934Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.34 76.6934H259.267V80.3699H269.34V76.6934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.675 84.8633H259.267V88.5398H277.675V84.8633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.038 84.8633H280.487V88.5398H294.038V84.8633Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.089 93.0332H269.392V96.7097H294.089V93.0332Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.732 93.0332H259.267V96.7097H266.732V93.0332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.198 101.203H259.267V104.88H274.198V101.203Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.038 101.203H276.652V104.88H294.038V101.203Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.015 122.956V123.978L289.231 125.407V124.386L291.89 123.416L289.231 122.446V121.476L293.015 122.956Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.226 121.526V122.497L279.567 123.467L282.226 124.437V125.458L278.442 124.028V123.007L282.226 121.526Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.726 118.718H287.902L285.09 126.786H283.914L286.726 118.718Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.528 52.0299V53.4086L270.517 55.298V53.9703L273.994 52.6938L270.517 51.4172V50.1406L275.528 52.0299Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.374 50.1406V51.4172L262.897 52.6938L266.374 53.9703V55.298L261.363 53.4086V52.0299L266.374 50.1406Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6587 162.624C26.3975 161.431 24.9372 160.436 23.4104 159.707C23.4104 159.707 23.3441 159.707 23.3441 159.641C21.1536 158.647 18.6975 158.183 16.2415 158.315C14.582 158.381 12.8562 158.779 11.2631 159.442C11.1303 159.508 11.0639 159.508 10.9312 159.575C8.01051 160.9 5.68724 163.022 4.16053 165.54C1.7045 169.65 1.23985 174.821 3.2976 179.461C6.68293 187.084 15.6441 190.464 23.2113 187.084C30.1811 183.968 33.6328 176.213 31.5751 169.12C31.3759 168.457 31.1768 167.86 30.8449 167.198C30.0483 165.474 28.9863 163.883 27.6587 162.624ZM21.3527 182.908C16.1087 185.228 9.86912 182.908 7.54585 177.605C6.1519 174.489 6.41741 171.042 8.01051 168.258C8.01051 168.258 8.01051 168.192 8.07689 168.192C9.13895 166.336 10.7984 164.745 12.9226 163.817C13.3208 163.618 13.7191 163.486 14.1174 163.353C14.1838 163.353 14.1838 163.353 14.2501 163.287C16.3743 162.69 18.4984 162.756 20.4898 163.419C22.2156 164.016 23.7423 165.01 24.9372 166.336C25.6673 167.131 26.2647 168.059 26.7294 169.054C26.9949 169.716 27.194 170.313 27.3932 170.976C28.3889 175.815 25.9992 180.853 21.3527 182.908Z",
    fill: "#64648E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4099 159.707C25.003 160.436 26.3969 161.43 27.6581 162.624C28.9857 163.883 30.0478 165.474 30.8443 167.264C31.1098 167.927 31.3754 168.523 31.5745 169.186L27.2599 171.108C27.1271 170.445 26.928 169.783 26.5961 169.186C26.1314 168.192 25.534 167.264 24.8038 166.468C23.609 165.143 22.0159 164.082 20.3564 163.552L23.2771 159.773",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.423 163.485C18.4316 162.822 16.2411 162.756 14.1834 163.352C14.117 163.352 14.117 163.352 14.0506 163.418L11.2627 159.507C12.9222 158.845 14.5816 158.447 16.2411 158.381C18.6971 158.248 21.1532 158.712 23.3437 159.706",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2979 188.477V189.802",
    stroke: "#FD783D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2979 192.32V211.345",
    stroke: "#FD783D",
    strokeMiterlimit: 10,
    strokeDasharray: "3.83 3.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2979 212.604V213.93H19.6254",
    stroke: "#FD783D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3467 213.93H59.187",
    stroke: "#FD783D",
    strokeMiterlimit: 10,
    strokeDasharray: "4.12 4.12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5811 213.93H61.9086V212.604",
    stroke: "#FD783D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9082 210.019V190.663",
    stroke: "#FD783D",
    strokeMiterlimit: 10,
    strokeDasharray: "3.89 3.89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9082 189.404V188.078",
    stroke: "#FD783D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.768 19.7734H55V158.817H171.768V19.7734Z",
    fill: "#49496B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.768 13H55V30.6602H171.768V13Z",
    fill: "#64648E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.262 149.263V150.412L154.083 151.984V150.896L157.051 149.807L154.083 148.719V147.63L158.262 149.263Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.33 147.63V148.719L143.363 149.807L146.33 150.896V151.984L142.151 150.412V149.263L146.33 147.63Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.713 146.174L150.054 159.767H148.857L152.516 146.174H153.713Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6782 41.8484V43.2999L77.4697 45.2957V43.9047L81.1641 42.5741L77.4697 41.2436V39.8525L82.6782 41.8484Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0484 39.8525V41.2436L69.3539 42.5741L73.0484 43.9047V45.2957L67.8398 43.2999V41.8484L73.0484 39.8525Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.508 53.7637H75.168V60.0536H109.508V53.7637Z",
    fill: "#54B3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.493 53.7637H114.354V60.0536H131.493V53.7637Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.11 53.7637H135.49V60.0536H159.11V53.7637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2175 64.9521H75.168V71.2421H91.2175V64.9521Z",
    fill: "#54B3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.953 64.9521H95.5781V71.2421H122.953V64.9521Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.17 64.9521H127.435V71.2421H159.17V64.9521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2443 76.2021H75.168V82.4921H96.2443V76.2021Z",
    fill: "#54B3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.366 76.2021H99.6963V82.4921H139.366V76.2021Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.17 76.2021H143.666V82.4921H159.17V76.2021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.756 87.3906H75.168V93.6806H101.756V87.3906Z",
    fill: "#54B3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.493 87.3906H105.692V93.6806H131.493V87.3906Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.11 87.3906H135.49V93.6806H159.11V87.3906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8569 98.5801H75.168V104.87H86.8569V98.5801Z",
    fill: "#54B3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.929 98.5801H90.7939V104.87H113.929V98.5801Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.17 98.5801H117.502V104.87H159.17V98.5801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.539 109.828H75.168V116.118H108.539V109.828Z",
    fill: "#54B3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.953 109.828H112.718V116.118H122.953V109.828Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.17 109.828H127.435V116.118H159.17V109.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.592 121.019H75.168V127.308H118.592V121.019Z",
    fill: "#54B3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.032 121.019H122.287V127.308H140.032V121.019Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.17 121.019H143.666V127.308H159.17V121.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4921 132.207H75.168V138.497H88.4921V132.207Z",
    fill: "#54B3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.54 132.207H92.3691V138.497H108.54V132.207Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.171 132.207H112.718V138.497H159.171V132.207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.984 53.7637H163.712V138.496H164.984V53.7637Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3866 60.0536C66.126 60.0536 67.536 58.6456 67.536 56.9086C67.536 55.1717 66.126 53.7637 64.3866 53.7637C62.6473 53.7637 61.2373 55.1717 61.2373 56.9086C61.2373 58.6456 62.6473 60.0536 64.3866 60.0536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3866 71.2421C66.126 71.2421 67.536 69.834 67.536 68.0971C67.536 66.3602 66.126 64.9521 64.3866 64.9521C62.6473 64.9521 61.2373 66.3602 61.2373 68.0971C61.2373 69.834 62.6473 71.2421 64.3866 71.2421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3866 82.4921C66.126 82.4921 67.536 81.084 67.536 79.3471C67.536 77.6102 66.126 76.2021 64.3866 76.2021C62.6473 76.2021 61.2373 77.6102 61.2373 79.3471C61.2373 81.084 62.6473 82.4921 64.3866 82.4921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3866 93.6806C66.126 93.6806 67.536 92.2725 67.536 90.5356C67.536 88.7987 66.126 87.3906 64.3866 87.3906C62.6473 87.3906 61.2373 88.7987 61.2373 90.5356C61.2373 92.2725 62.6473 93.6806 64.3866 93.6806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3866 104.87C66.126 104.87 67.536 103.462 67.536 101.725C67.536 99.9881 66.126 98.5801 64.3866 98.5801C62.6473 98.5801 61.2373 99.9881 61.2373 101.725C61.2373 103.462 62.6473 104.87 64.3866 104.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3866 116.118C66.126 116.118 67.536 114.71 67.536 112.973C67.536 111.236 66.126 109.828 64.3866 109.828C62.6473 109.828 61.2373 111.236 61.2373 112.973C61.2373 114.71 62.6473 116.118 64.3866 116.118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3866 127.308C66.126 127.308 67.536 125.9 67.536 124.164C67.536 122.427 66.126 121.019 64.3866 121.019C62.6473 121.019 61.2373 122.427 61.2373 124.164C61.2373 125.9 62.6473 127.308 64.3866 127.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3866 138.496C66.126 138.496 67.536 137.088 67.536 135.351C67.536 133.614 66.126 132.206 64.3866 132.206C62.6473 132.206 61.2373 133.614 61.2373 135.351C61.2373 137.088 62.6473 138.496 64.3866 138.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.619 22.7972C166.619 24.5512 165.165 26.0027 163.409 26.0027C161.653 26.0027 160.199 24.5512 160.199 22.7972C160.199 21.0433 161.653 19.5918 163.409 19.5918C165.165 19.5918 166.619 20.9828 166.619 22.7972Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.62 37.606C159.62 39.5283 158.027 41.1192 156.102 41.1192C154.177 41.1192 152.584 39.5283 152.584 37.606C152.584 35.6837 154.177 34.0928 156.102 34.0928C158.027 34.0928 159.62 35.6837 159.62 37.606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3592 110.73V109.567C31.4033 109.567 32.1317 109.348 32.5444 108.911C32.9633 108.473 33.1728 107.742 33.1728 106.716V103.715C33.1728 102.852 33.254 102.105 33.4166 101.474C33.5854 100.842 33.8574 100.32 34.2326 99.9073C34.6077 99.4946 35.1079 99.1883 35.7331 98.9882C36.3584 98.7881 37.1306 98.6881 38.0497 98.6881V100.526C37.3244 100.526 36.7523 100.639 36.3334 100.864C35.9207 101.089 35.6268 101.439 35.4518 101.914C35.283 102.383 35.1986 102.983 35.1986 103.715V107.466C35.1986 107.954 35.1329 108.398 35.0016 108.798C34.8766 109.198 34.6421 109.542 34.2982 109.83C33.9543 110.118 33.4635 110.339 32.8258 110.496C32.1943 110.652 31.3721 110.73 30.3592 110.73ZM38.0497 122.697C37.1306 122.697 36.3584 122.597 35.7331 122.397C35.1079 122.197 34.6077 121.891 34.2326 121.478C33.8574 121.066 33.5854 120.543 33.4166 119.912C33.254 119.28 33.1728 118.533 33.1728 117.67V114.669C33.1728 113.644 32.9633 112.912 32.5444 112.475C32.1317 112.037 31.4033 111.818 30.3592 111.818V110.655C31.3721 110.655 32.1943 110.733 32.8258 110.89C33.4635 111.046 33.9543 111.268 34.2982 111.556C34.6421 111.843 34.8766 112.187 35.0016 112.587C35.1329 112.987 35.1986 113.431 35.1986 113.919V117.67C35.1986 118.402 35.283 119.002 35.4518 119.471C35.6268 119.94 35.9207 120.287 36.3334 120.512C36.7523 120.744 37.3244 120.859 38.0497 120.859V122.697ZM30.3592 111.818V109.567H32.5725V111.818H30.3592ZM37.9746 142.655V143.818C36.9305 143.818 36.1989 144.037 35.78 144.475C35.3674 144.912 35.161 145.644 35.161 146.669V149.67C35.161 150.533 35.0766 151.28 34.9078 151.912C34.7453 152.543 34.4764 153.066 34.1013 153.478C33.7261 153.891 33.2259 154.197 32.6007 154.397C31.9754 154.597 31.2032 154.697 30.2841 154.697V152.859C31.0094 152.859 31.5784 152.744 31.9911 152.512C32.41 152.287 32.7038 151.94 32.8726 151.471C33.0477 151.002 33.1353 150.402 33.1353 149.67V145.919C33.1353 145.431 33.1978 144.987 33.3228 144.587C33.4541 144.187 33.6917 143.843 34.0356 143.556C34.3795 143.268 34.8672 143.046 35.4987 142.89C36.1364 142.733 36.9617 142.655 37.9746 142.655ZM30.2841 130.688C31.2032 130.688 31.9754 130.788 32.6007 130.988C33.2259 131.188 33.7261 131.495 34.1013 131.907C34.4764 132.32 34.7453 132.842 34.9078 133.474C35.0766 134.105 35.161 134.852 35.161 135.715V138.716C35.161 139.742 35.3674 140.473 35.78 140.911C36.1989 141.348 36.9305 141.567 37.9746 141.567V142.73C36.9617 142.73 36.1364 142.652 35.4987 142.496C34.8672 142.339 34.3795 142.118 34.0356 141.83C33.6917 141.542 33.4541 141.198 33.3228 140.798C33.1978 140.398 33.1353 139.954 33.1353 139.466V135.715C33.1353 134.983 33.0477 134.383 32.8726 133.914C32.7038 133.439 32.41 133.089 31.9911 132.864C31.5784 132.639 31.0094 132.526 30.2841 132.526V130.688ZM37.9746 141.567V143.818H35.7613V141.567H37.9746Z",
    fill: "#323247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4824 37H8V42.0042H18.4824V37Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4824 45.7314H8V50.7356H18.4824V45.7314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4824 54.5146H8V59.5188H18.4824V54.5146Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4824 63.2461H8V68.2502H18.4824V63.2461Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4824 71.9775H8V76.9817H18.4824V71.9775Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4824 80.71H8V85.7141H18.4824V80.71Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4824 89.4922H8V94.4963H18.4824V89.4922Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.626 219.78C336.626 219.729 336.626 219.729 336.626 219.678C336.626 219.627 336.626 219.627 336.626 219.576C337.138 219.321 337.7 219.066 338.211 218.708C338.774 218.351 339.336 217.891 339.848 217.38L339.745 216.921C339.643 216.41 339.439 215.951 339.285 215.44C339.183 215.185 339.081 214.98 338.978 214.725C338.876 214.47 338.723 214.266 338.62 214.061L338.365 213.653C337.649 213.653 336.933 213.755 336.268 213.857C335.655 213.959 335.092 214.163 334.581 214.368L334.427 214.215C334.632 213.653 334.785 213.091 334.939 212.529C335.041 211.866 335.143 211.151 335.143 210.436L334.734 210.181C334.53 210.027 334.274 209.925 334.07 209.823C333.814 209.721 333.609 209.568 333.354 209.517C332.842 209.364 332.382 209.159 331.871 209.057L331.359 208.955C330.848 209.466 330.388 210.027 330.03 210.589C329.672 211.1 329.416 211.61 329.161 212.172C329.11 212.172 329.11 212.172 329.058 212.172C329.007 212.172 329.007 212.172 328.956 212.172C328.7 211.661 328.445 211.1 328.087 210.589C327.729 210.027 327.269 209.466 326.757 208.955L326.297 209.057C325.786 209.159 325.326 209.364 324.814 209.517C324.559 209.619 324.354 209.721 324.098 209.823C323.843 209.925 323.638 210.078 323.434 210.181L323.025 210.436C323.025 211.151 323.127 211.866 323.229 212.529C323.331 213.142 323.536 213.704 323.74 214.215C323.689 214.266 323.638 214.317 323.587 214.368C323.025 214.163 322.462 214.01 321.9 213.857C321.235 213.755 320.519 213.653 319.803 213.653L319.548 214.061C319.394 214.266 319.292 214.521 319.19 214.725C319.087 214.98 318.985 215.185 318.883 215.44C318.678 215.951 318.525 216.41 318.423 216.921L318.32 217.38C318.832 217.891 319.394 218.351 319.957 218.708C320.468 219.066 320.979 219.321 321.542 219.576C321.542 219.627 321.542 219.627 321.542 219.678C321.542 219.729 321.542 219.729 321.542 219.78C321.03 220.036 320.468 220.291 319.957 220.648C319.394 221.006 318.832 221.465 318.32 221.976L318.423 222.436C318.525 222.946 318.729 223.406 318.883 223.916C318.985 224.172 319.087 224.376 319.19 224.631C319.292 224.887 319.445 225.091 319.548 225.295L319.803 225.704C320.519 225.704 321.235 225.602 321.9 225.499C322.513 225.397 323.076 225.193 323.587 224.989C323.638 225.04 323.689 225.091 323.74 225.142C323.536 225.704 323.383 226.265 323.229 226.827C323.127 227.491 323.025 228.206 323.025 228.921L323.434 229.176C323.638 229.329 323.894 229.431 324.098 229.533C324.354 229.636 324.559 229.789 324.814 229.84C325.326 230.044 325.786 230.197 326.297 230.299L326.757 230.401C327.269 229.891 327.729 229.329 328.087 228.767C328.445 228.257 328.7 227.746 328.956 227.185C329.007 227.185 329.007 227.185 329.058 227.185C329.11 227.185 329.11 227.185 329.161 227.185C329.416 227.695 329.672 228.257 330.03 228.767C330.388 229.329 330.848 229.891 331.359 230.401L331.82 230.299C332.331 230.197 332.791 229.993 333.303 229.84C333.558 229.738 333.763 229.636 334.018 229.533C334.274 229.431 334.479 229.278 334.683 229.176L335.092 228.921C335.092 228.206 334.99 227.491 334.888 226.827C334.785 226.214 334.581 225.653 334.376 225.142C334.427 225.091 334.479 225.04 334.53 224.989C335.092 225.193 335.655 225.346 336.217 225.499C336.882 225.602 337.598 225.704 338.314 225.704L338.569 225.295C338.723 225.091 338.825 224.836 338.927 224.631C339.03 224.376 339.183 224.172 339.234 223.916C339.387 223.406 339.592 222.946 339.694 222.436L339.797 221.976C339.285 221.465 338.723 221.006 338.16 220.648C337.649 220.342 337.138 220.036 336.626 219.78ZM329.058 223.304C327.064 223.304 325.428 221.67 325.428 219.678C325.428 217.687 327.064 216.053 329.058 216.053C331.053 216.053 332.689 217.687 332.689 219.678C332.689 221.67 331.053 223.304 329.058 223.304Z",
    fill: "#323247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.441 206.402H298.686V227.849H303.441V206.402Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.793 215.849H291.68V227.848H296.793V215.849Z",
    fill: "#64648E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.686 219.679H284.572V227.849H289.686V219.679Z",
    fill: "#FD783D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.869 205H111.113V226.446H115.869V205Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.221 214.446H104.107V226.446H109.221V214.446Z",
    fill: "#64648E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.113 218.276H97V226.446H102.113V218.276Z",
    fill: "#FD783D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.702 224.428H282.68",
    stroke: "#FD783D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.073 224.428H276.187",
    stroke: "#FD783D",
    strokeMiterlimit: 10,
    strokeDasharray: "5.07 5.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.857 224.428H273.834V225.449",
    stroke: "#FD783D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.834 227.39V241.687",
    stroke: "#FD783D",
    strokeMiterlimit: 10,
    strokeDasharray: "3.74 3.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.834 242.657V243.678H274.857",
    stroke: "#FD783D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.595 243.679H282.68",
    stroke: "#FD783D",
    strokeMiterlimit: 10,
    strokeDasharray: "3.4 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.55 243.679H284.572",
    stroke: "#FD783D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.707 242.708H286.208V245.108H299.707V242.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.565 247.201H286.208V249.601H295.565V247.201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.02 251.644H286.208V254.043H298.02V251.644Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.236 251.644H300.475V254.043H303.236V251.644Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.968 251.644H305.792V254.043H315.968V251.644Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.917 247.201H298.531V249.601H315.917V247.201Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.916 242.708H302.417V245.108H315.916V242.708Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.296 218.402H353.398V222.641H362.296V218.402Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.296 225.807H353.398V230.045H362.296V225.807Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.296 233.211H353.398V237.449H362.296V233.211Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.296 240.614H353.398V244.852H362.296V240.614Z",
    fill: "#B83D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.296 248.07H353.398V252.309H362.296V248.07Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.296 255.474H353.398V259.712H362.296V255.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.296 262.878H353.398V267.116H362.296V262.878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.434 279.268C320.111 279.523 317.298 278.706 314.997 277.276C305.589 271.455 303.646 255.115 303.492 253.89C303.594 254.247 304.515 256.29 314.281 262.826C315.1 263.387 315.815 263.949 316.531 264.511C316.531 264.511 316.531 264.511 316.582 264.562C325.071 271.557 323.434 279.268 323.434 279.268Z",
    fill: "#0C8068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.543 253.839C303.543 253.839 312.338 275.336 322.053 277.583",
    stroke: "#0A6D53",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M323.434 279.268C320.11 279.523 317.298 278.706 314.997 277.277C316.889 272.834 316.531 264.46 316.531 264.46C316.531 264.46 316.531 264.46 316.582 264.511C325.07 271.558 323.434 279.268 323.434 279.268Z",
    fill: "#0A6D53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.388 255.064C348.337 255.269 348.235 256.086 347.979 257.26C346.598 263.439 341.587 280.136 328.139 278.451C328.139 278.451 327.934 277.021 328.344 274.877C329.008 271.711 331.156 267.064 337.65 263.132C347.314 257.311 348.286 255.422 348.388 255.064Z",
    fill: "#0C8068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.979 256.392C347.979 256.392 341.076 274.264 329.11 277.889",
    stroke: "#0A6D53",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M347.979 257.26C346.598 263.438 341.587 280.136 328.139 278.451C328.139 278.451 327.934 277.021 328.344 274.876C339.542 275.489 347.979 257.26 347.979 257.26Z",
    fill: "#0A6D53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.371 279.064C327.014 279.625 322.105 277.583 319.906 271.711C318.576 268.187 318.219 263.234 320.417 256.647C326.195 239.337 323.792 236.069 323.741 235.967C323.843 236.018 328.854 238.52 332.127 244.545C335.706 251.235 337.087 262.213 327.371 279.064Z",
    fill: "#159A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.741 235.967C323.741 235.967 331.258 245.464 328.394 263.49C325.531 281.515 327.372 279.115 327.372 279.115",
    stroke: "#0C8068",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M327.372 279.063C327.014 279.625 322.105 277.583 319.906 271.71C332.281 275.234 332.127 244.545 332.127 244.545C335.707 251.234 337.087 262.213 327.372 279.063Z",
    fill: "#0C8068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.543 253.839C303.543 253.839 303.543 253.839 303.543 253.89C303.492 253.839 303.543 253.839 303.543 253.839Z",
    fill: "#0C8068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.934 278.809V292.698C336.934 296.732 333.661 300.051 329.571 300.051H323.025C320.366 300.051 318.065 298.621 316.736 296.527C316.071 295.404 315.662 294.127 315.662 292.698V278.86H336.934V278.809Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.701 277.021H314.946C314.639 277.021 314.384 277.277 314.384 277.583V278.298C314.384 278.604 314.639 278.86 314.946 278.86H337.701C338.008 278.86 338.263 278.604 338.263 278.298V277.583C338.212 277.277 338.008 277.021 337.701 277.021Z",
    fill: "#EBA154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.934 278.809V292.698C336.934 296.732 333.662 300.051 329.571 300.051H323.026C320.367 300.051 318.066 298.621 316.736 296.527C332.281 301.378 335.656 289.991 335.042 285.447C334.429 280.902 328.855 278.86 328.855 278.86H336.934V278.809Z",
    fill: "#DC831E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1039_12464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 389,
    height: 300,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceBox8);
export default __webpack_public_path__ + "static/media/ServiceBox8.f59b907240d960797084865d8423accf.svg";
export { ForwardRef as ReactComponent };